import React from 'react'
import { Grid, makeStyles, Typography, Avatar, useTheme } from '@material-ui/core'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'


const useStyles = makeStyles((theme) => ({
	gridRoot: {
		paddingBottom: '22px'
	},
	titleRoot: {
		textAlign: 'left',
		fontWeight: 'bold',
		width: '100%',
		fontSize: '21px'
	},
	titleCaseContainer: {
		textAlign: 'right',
		width: '100%'
	},
	titleCase: {
		display: 'inline-block',
		textAlign: 'left',
		fontWeight: 'bold',
		fontSize: '20px',
		paddingRight: '10px'
	},
	titleCaseId: {
		display: 'inline-block',
		textAlign: 'right',
		fontSize: '20px'
	},
	gridContainer: {
		background: '#FFFFFF',
		boxShadow: '0 5px 10px rgba(0,0,0,0.09), 0 3px 3px rgba(0,0,0,0.13)',
		borderRadius: '4px',
		padding: '24px 16px 16px'
	},
	smallText: {
		fontSize: '20px'
	},
	titleText: {
		fontWeight: '700',
		fontSize: '20px'
	},
	contactWrap: {
		display: 'flex',
		flexWrap: 'wrap',
		alignItems: 'center',
	},
	avatarWrap: {
		paddingRight: '18px',
		[theme.breakpoints.down('xs')]: {
			paddingRight: '10px',
		},
	},
	separator: {
		background: '#000',
		width: '49px',
		height: '1px',
		margin: '15px 0 25px',
	  },
	aliasName: {
		fontSize: '18px',
		color: '#11121C', 
		fontWeight: 'bold', 
		lineHeight: '21px',
		marginBottom: '24px',
		marginTop: '8px'
	},
	caseDate: {
		fontSize: '16px',
		color: '#11121C', 
		fontWeight: 'bold', 
		lineHeight: '21px',		
	},
	caseDateTitle: {
		fontSize: '13px',
	},
	summaryProgress: {
		marginBottom: '62px'
	},
	summaryProgressCount: {
		fontSize: '16px',
		fontWeight: 'bold',
		display: 'inline',
		marginRight: '5px'
	},
	summaryProgressText: {
		fontSize: '16px',
		display: 'inline'
	},
	manageCaseTeam: {
		flexWrap: 'nowrap',
		marginBottom: '8px',
		alignItems: 'center'
	},
	manageCaseContact: {
		flexWrap: 'nowrap',
		marginTop: '25px',
		marginBottom: '16px',
		alignItems: 'center'
	},
	teamName: {
		fontSize: '16px',
		color: '#11121C', 
		fontWeight: 'bold', 
		lineHeight: '21px',		
	},
	teamText: {
		fontSize: '16px',
	}
}))


const InviteInformation = ({
    intl,
    creatorInfo
}) => {
	const classes = useStyles()
	const theme = useTheme()

    return (
		<Grid data-testid="case-summary" className={classes.gridRoot}>
			<Grid container direction='column' data-testid="case-summary-content" className={classes.gridContainer}>
				<Grid item xs={12}>
					<Typography data-testid="manage-case-title" variant='h4' className={classes.titleRoot}>
						{intl.formatMessage({ id: 'app.dashboard.myHealthcareTeam' })}
					</Typography>
					<div className={classes.separator}></div>
				</Grid>
				<Grid container direction='column'>
					<Grid container data-testid="manage-case-team" className={classes.manageCaseTeam}>
						{creatorInfo && creatorInfo.teamLogo &&
							<Grid item className={classes.avatarWrap}>
								<Avatar data-testid="manage-case-team-avatar" alt='' src={creatorInfo.teamLogo ? creatorInfo.teamLogo : ''}
									style={{ width: theme.spacing(7), height: theme.spacing(7) }}
								/>
							</Grid>
						}
						<Grid item>
							{creatorInfo && creatorInfo.teamName && (
								<Typography data-testid="manage-case-team-name" className={classes.teamName}>{creatorInfo.teamName}</Typography>
							)}
						</Grid>
					</Grid>
					<Grid item>
						{creatorInfo && (creatorInfo.teamStreetAddress || creatorInfo.teamCity || creatorInfo.teamState || creatorInfo.teamCountry || creatorInfo.teamPostalCode) && (
							<Typography data-testid="manage-case-team-address" className={classes.teamText}>											
								<span style={{ display: 'block' }}>{creatorInfo.teamStreetAddress}, {creatorInfo.teamCity}</span>
								<span style={{ display: 'block' }}>{creatorInfo.teamState}</span>
								<span style={{ display: 'block' }}>{creatorInfo.teamPostalCode}</span>
								<span style={{ display: 'block' }}>{creatorInfo.teamCountry}</span>
								<span style={{ display: 'block' }}>{creatorInfo.teamPhoneNumber}</span>
							</Typography>
						)}
					</Grid>
					<Grid container data-testid="manage-case-contact" className={classes.manageCaseContact}>
						{creatorInfo && (
							<Grid item className={classes.avatarWrap}>
								{creatorInfo.logo && (
									<Avatar data-testid="manage-case-contact-avatar" alt='' src={creatorInfo.logo ? creatorInfo.logo : ''}
										style={{ width: theme.spacing(7), height: theme.spacing(7) }}
									/>
								)}
							</Grid>
						)}
						{creatorInfo && (creatorInfo.firstName || creatorInfo.lastName || creatorInfo.credentials) && (
							<Grid item data-testid="manage-case-creator">
								<Typography data-testid="manage-case-creator-title" className={classes.teamName}>
									{creatorInfo.firstName} {creatorInfo.lastName}
									{creatorInfo.credentials && ', ' + creatorInfo.credentials}
								</Typography>
							</Grid>
						)}
					</Grid>
					
				</Grid>

				
			</Grid>

		</Grid>
    )
}

const mapStateToProps = (state, ownProps) => ({})

const mapDispatchToProps = (dispatch, ownProps) => ({})

const enhance = compose(
    connect(mapStateToProps, mapDispatchToProps),
    injectIntl
)

export default enhance(InviteInformation)